const MayaOutlinerRowShell = ({
  depth = 0,
  layout = 'row',
  selectionTier = 'none',
  className = '',
  children,
}) => (
  <div
    className={[
      'maya-outliner-row-shell',
      layout === 'panel' ? 'has-panel-row' : 'has-static-row',
      selectionTier === 'primary' ? 'is-outliner-primary' : '',
      selectionTier === 'ancestor' ? 'is-outliner-ancestor' : '',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
    style={{ '--outliner-depth': depth }}
  >
    {layout === 'panel' ? (
      <div className="maya-outliner-panel-row-wrap">{children}</div>
    ) : (
      <div className="maya-outliner-static-row-wrap">{children}</div>
    )}
  </div>
)

export default MayaOutlinerRowShell
